import { buttonPlaceholder } from '@entities/leadCollector';
import * as stylex from '@stylexjs/stylex';
import { useEffect, useRef } from 'react';
import { styles } from './styles';

interface FormButtonProps {
  onChange: (textButton: string) => void;
  isCanEdit: boolean;
  onButtonClick: () => void;
  value: Record<string, unknown>;
}

export const FormButton = ({ onChange, isCanEdit, onButtonClick, value }: FormButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleBlurButton = (e: React.FocusEvent<HTMLButtonElement>) => {
    if (buttonRef.current && !e.currentTarget.textContent?.trim()) {
      buttonRef.current.textContent = buttonPlaceholder;
    }

    onChange(e.currentTarget.textContent?.trim() || '');
  };

  const handleFocusButton = () => {
    if (buttonRef.current && buttonRef.current.textContent === buttonPlaceholder) {
      buttonRef.current.textContent = '';
      buttonRef.current.focus();
    }
  };

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.textContent = `${value.textButton || buttonPlaceholder}`;
    }
  }, []);

  return (
    <button
      {...stylex.props(styles.button, isCanEdit && styles.buttonPointer)}
      onClick={isCanEdit ? onButtonClick : undefined}
    >
      <span
        {...stylex.props(styles.buttonText)}
        ref={buttonRef}
        suppressContentEditableWarning
        contentEditable={!isCanEdit}
        onBlur={handleBlurButton}
        onMouseUp={isCanEdit ? undefined : handleFocusButton}
      >
        {buttonRef.current?.textContent || buttonPlaceholder}
      </span>
    </button>
  );
};
